"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgTrash = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 22, height: 25, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { opacity: 0.4, d: "M19.522 9.008s-.646 8.274-1.02 11.76c-.179 1.664-1.174 2.64-2.805 2.67-3.102.058-6.209.062-9.31-.006-1.569-.033-2.547-1.02-2.722-2.656-.377-3.516-1.02-11.768-1.02-11.768", stroke: "#191933", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), (0, jsx_runtime_1.jsx)("path", { d: "M21.167 5.04H1M17.281 5.042c-.933 0-1.737-.682-1.92-1.627l-.29-1.494a1.53 1.53 0 0 0-1.47-1.166H8.565a1.53 1.53 0 0 0-1.47 1.166l-.29 1.494c-.183.945-.987 1.627-1.92 1.627", stroke: "#191933", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }))); };
exports.default = SvgTrash;
